import { ActivityMetaType, type ActivityMeta } from '@/models/Activity';

export const writeActivityMetaMap: Record<number, ActivityMeta> = {
  40030: {
    name: 'Dare To',
    type: ActivityMetaType.write,
    icon: 'pen-clip',
  },
  40032: {
    name: 'My skills',
    type: ActivityMetaType.write,
    icon: 'pen-clip',
  },
  40033: {
    name: 'Go Grammar',
    type: ActivityMetaType.write,
    icon: 'pen-clip',
  },
  40034: {
    name: 'To do!',
    type: ActivityMetaType.write,
    icon: 'pen-clip',
  },
};
